import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Para formato en español
dayjs.locale('es');

export const transformDataPosTable = (data = []) => {
    return data.map((item, idx) => ({
        id: `#${item.id}`,
        cliente: item.client.name,
        puntoVenta: item.name,
        direccion: item.address || `${item.country}, ${item.country_alfa_2}`,
        droguerias: item.drugManufacturers || [],
        alta: dayjs(item.created_at).format('D MMMM YYYY'),
        actualizado: dayjs(item.updated_at).format('D MMMM YYYY'),
        // alerta: item.alerts?.length > 0 ? 'Sí' : 'No',
        // estado: item.is_demo ? 'Demo' : item.is_free_trial ? 'Trial' : 'Activo',
    }));
};

export const columns = [
    { key: 'id', label: 'ID', width: 62 },
    { key: 'puntoVenta', label: 'Punto de venta', width: 129 },
    { key: 'direccion', label: 'Dirección', width: 178 },
    { key: 'droguerias', label: 'Droguerías', width: 182 },
    { key: 'alta', label: 'Alta', width: 125 },
    { key: 'actualizado', label: 'Actualizado', width: 125 },
    { key: 'alerta', label: 'Alerta', width: 119 },
    { key: 'estado', label: 'Estado', width: 112 },
];

export const columnsWithClient = [
    { key: 'id', label: 'ID', width: 62 },
    { key: 'cliente', label: 'Cliente', width: 105 },
    { key: 'puntoVenta', label: 'Punto de venta', width: 129 },
    { key: 'direccion', label: 'Dirección', width: 178 },
    { key: 'droguerias', label: 'Droguerías', width: 182 },
    { key: 'alta', label: 'Alta', width: 125 },
    { key: 'actualizado', label: 'Actualizado', width: 125 },
    { key: 'alerta', label: 'Alerta', width: 119 },
    { key: 'estado', label: 'Estado', width: 112 },
];
